<template>
	
	<v-flex style="">
		<v-data-table 
			:headers="headers"
			:items="PIs"
			hide-actions
			class="PITable"
			>
		  	<template slot="items" slot-scope="props">
				<td>{{ props.item.name }}</td>
				<td>{{ props.item.title }}</td>

				<td class="justify-center  pr-3">
					<v-tooltip left v-if="isSuperUser || isManagerOfRoom(room) || isOccupantEditorOfDept(room.PCT[deptSelectedIndex])">
	              		<v-dialog slot="activator" v-model="removeDialog[props.index]" persistent max-width="290">
		                
		                	<v-icon slot="activator" small color="red lighten-2">close</v-icon>
		                
			                <v-card class="pl-2 pt-1 pr-2">
						        <v-card-title class="headline">Delete</v-card-title>
						        <v-divider></v-divider>
						        <v-card-text class="pt-4 body-2">Delete {{props.item.name}} from room?</v-card-text>
						        <v-card-actions>
						          	<v-spacer></v-spacer>
						          	<v-btn color="green darken-1" flat @click.native="removeDialog[props.index] = false">No</v-btn>
						          	<v-btn color="green darken-1" flat 
						          		@click="removePI(props.item, props.index)">Yes
						      	 	 </v-btn> 
						        </v-card-actions>
					      	</v-card>
				    	</v-dialog>
		                <span>Delete</span>
		            </v-tooltip>
				</td>
		  	</template>
		  	<template slot="no-data">
				No PIs
		  	</template>
		</v-data-table>
		<OccupantHistoryDialog :selectedRoom="room" class="ml-2" />
	</v-flex>
	
</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import OccupantHistoryDialog from '@/components/OccupantHistoryDialog'


export default {
data () {
	return {	removeDialog: {},
				headers: [
			        { text: 'Name',	align: 'left',	value: 'name' },
			        { text: 'Title', value: 'title' },
			        { text: '', value: 'name', sortable: false },
			      ],
	}
},

components: { OccupantHistoryDialog, },

computed: {
	...mapState({   	room: 				state => state.dv.room,
						deptSelectedIndex: 	state => state.dv.deptSelectedIndex,
						isSuperUser: state => state.user.isSuperUser,
				}),
	...mapGetters(['allowManagerUI', 'isManagerOfRoom', 'isOccupantEditorOfDept']),

	PIs: function () {
		return this.room ? this.room.PCT[this.deptSelectedIndex].PI : []
	},

	


},

methods : {
	...mapMutations([]),

	...mapActions([	'deletePI', 'fetchFullRoom', 'setRoom' ]),

	removePI: function (pi, index) {
		this.deletePI( { 'key': pi.key } )
		.then(() => {
			this.removeDialog[index] = false
			this.refreshRoom()
		})
	},

	refreshRoom: function () {
		this.fetchFullRoom({bldgAlpha: this.room.bldgAlpha, number: this.room.number, noSet: true}).then((data) => this.setRoom(data) )
	}
},
}

</script>

<style>
.pitile > .v-list__tile {
	height: 20px;
}

.PITable {
	height: 390px !important; 
	overflow-y: auto;
}

/* this technique gets deeply nested th td selectors */
.PITable th { padding-left: 20px !important; }
.PITable td { padding-left: 20px !important; }
.PITable .v-table__overflow { 
	overflow-x: unset !important;
	overflow-y: unset !important;
 }

 .PITable .table {
 	padding-left: 30px;
 	border-radius: 0px;
 }
</style>



// WEBPACK FOOTER //
// src/components/RoomViewer/RoomDetailPIs.vue